import { render, staticRenderFns } from "./test-builder.vue?vue&type=template&id=5126391a&"
import script from "./test-builder.vue?vue&type=script&lang=js&"
export * from "./test-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports